import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navLinks, siteInfo } from '@/mocks/site';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-colors duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur border-b border-background-200'
          : 'bg-background-50/70 backdrop-blur-sm border-b border-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-8 h-16 md:h-20 flex items-center justify-between" aria-label="主导航">
        <Link to="/" className="flex items-center gap-2.5 group cursor-pointer" aria-label={`${siteInfo.name} 首页`}>
          <span className="w-10 h-10 rounded-2xl bg-primary-500 text-background-50 flex items-center justify-center text-xl transition-transform duration-300 group-hover:rotate-6">
            <i className="ri-gift-2-fill"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg md:text-xl text-foreground-950">{siteInfo.name}</span>
            <span className="text-[11px] text-foreground-500 mt-0.5 hidden sm:block">吃瓜娱乐福利站</span>
          </span>
        </Link>

        <ul className="hidden md:flex items-center gap-1">
          {navLinks.map((item) => (
            <li key={item.path}>
              <Link
                to={item.path}
                className={`block px-4 py-2 rounded-full text-sm transition-colors cursor-pointer ${
                  isActive(item.path)
                    ? 'bg-primary-100 text-primary-800 font-medium'
                    : 'text-foreground-700 hover:text-primary-700 hover:bg-background-100'
                }`}
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/activities"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-gift-line"></i>
            去领福利
          </Link>
        </div>

        <button
          type="button"
          aria-label={menuOpen ? '关闭菜单' : '打开菜单'}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((v) => !v)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-full text-foreground-900 hover:bg-background-100 transition-colors cursor-pointer text-xl"
        >
          <i className={menuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
        </button>
      </nav>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50">
          <ul className="px-4 py-4 flex flex-col gap-1">
            {navLinks.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={`block px-4 py-3 rounded-xl text-base transition-colors cursor-pointer ${
                    isActive(item.path)
                      ? 'bg-primary-100 text-primary-800 font-medium'
                      : 'text-foreground-800 hover:bg-background-100'
                  }`}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
          <div className="px-4 pb-5">
            <Link
              to="/activities"
              className="flex items-center justify-center gap-2 w-full px-5 py-3 rounded-xl bg-primary-500 text-background-50 text-base font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-gift-line"></i>
              去领福利
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}